import * as React from 'react'
import * as moment from 'moment'
import { useMutation } from '@apollo/react-hooks'
import { redirect } from 'web-ui/dist/helpers/redirect'

import { DUPLICATE_PROJECT } from '../../../../mutations/DuplicateProject'
import { filterOptionsHelper } from '../../../../helpers/filterOptionsHelper'
import { locationsHelper } from '../../../../helpers/locationHelpers'
import { priceCurrencyFormater } from '../../../../helpers/priceCurrencyFormater'

import EnvironmentContext from '../../../EnvironmentContext/EnvironmentContext'
import { client as apolloClient } from '../../../ApolloProvider/ApolloProvider'

import { Item, PopupMenu, ProjectName, ProjectWrapper, Thumbnail } from './BrandOrderListNew.style'

export interface BrandOrderListNewItemProps {
  project?: any
  refetch?: () => void
  brandOrderUuid?: string
  sendDataToParent?: (data) => void
  optionDropdownData?: []
}

const BrandOrderListNewItem: React.FC<BrandOrderListNewItemProps> = ({
  project,
  refetch,
  brandOrderUuid,
  sendDataToParent,
  optionDropdownData,
}) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false)
  const { GEN1_BASE_URL, ORDER_SUMMARY_URL } = React.useContext(EnvironmentContext) || ''

  const [
    duplicateProject,
    { loading: duplicateProjectLoading, data: duplicatedProjectData },
  ] = useMutation(DUPLICATE_PROJECT, {
    client: apolloClient,
  })
  const [
    reOrderProject,
    { loading: reOrderProjectLoading, data: reOrderProjectData },
  ] = useMutation(DUPLICATE_PROJECT, {
    client: apolloClient,
  })

  React.useEffect(
    () => {
      sendDataToParent && sendDataToParent(duplicateProjectLoading || reOrderProjectLoading)
    },
    [duplicateProjectLoading, reOrderProjectLoading]
  )

  React.useEffect(
    () => {
      if (duplicatedProjectData && duplicatedProjectData.duplicateProject) {
        if (duplicatedProjectData.duplicateProject.projectLevel === 'TEMPLATES') {
          const duplicateProject1 = async () => {
            redirect(`/brand-dashboard/orders/${brandOrderUuid}`)

            if (refetch) {
              refetch()
            }
          }
          duplicateProject1()
        }
        if (duplicatedProjectData.duplicateProject.projectLevel === 'LEVEL2') {
          window.location.href = `${GEN1_BASE_URL}/video_projects/${
            duplicatedProjectData.duplicateProject.uuid
          }`
        }
        if (
          duplicatedProjectData.duplicateProject.projectLevel !== 'LEVEL2' &&
          duplicatedProjectData.duplicateProject.projectLevel !== 'TEMPLATES'
        ) {
          window.location.href = `${GEN1_BASE_URL}/video_projects/${
            duplicatedProjectData.duplicateProject.uuid
          }`
        }
      }
    },
    [duplicatedProjectData]
  )

  React.useEffect(
    () => {
      if (reOrderProjectData && reOrderProjectData.duplicateProject) {
        window.location.href = `${GEN1_BASE_URL}/video_projects/${
          reOrderProjectData.duplicateProject.uuid
        }`
      }
    },
    [reOrderProjectData]
  )

  const burgerIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6 15.8C11.6 16.7941 10.7941 17.6 9.8 17.6C8.80589 17.6 8 16.7941 8 15.8C8 14.8059 8.80589 14 9.8 14C10.7941 14 11.6 14.8059 11.6 15.8ZM18.2 15.8C18.2 16.7941 17.3941 17.6 16.4 17.6C15.4059 17.6 14.6 16.7941 14.6 15.8C14.6 14.8059 15.4059 14 16.4 14C17.3941 14 18.2 14.8059 18.2 15.8ZM22.9999 17.6C23.9941 17.6 24.7999 16.7941 24.7999 15.8C24.7999 14.8059 23.9941 14 22.9999 14C22.0058 14 21.2 14.8059 21.2 15.8C21.2 16.7941 22.0058 17.6 22.9999 17.6Z"
        fill="#1E1E21"
      />
    </svg>
  )
  const {
    orderType: orderSource,
    name,
    imageUrl: thumbnailUrl,
    id: uuid,
    locations,
    projectStatus,
    contractType,
    dueDate,
    createdAt,
    orderType,
    numberOfShoots: shoots,
    numberOfVideos: videos,
    orderPrice: price,
    orderCurrency,
    paymentType,
  } = project || {}

  const projectDate = moment(new Date(dueDate)).format('DD MMM YYYY')
  const createdDate = moment(new Date(createdAt)).format('DD MMM YYYY')

  const triggerRef = React.useRef(null)

  const outsideClick = ref => {
    React.useEffect(
      () => {
        const handleClickOutside = event => {
          if (ref.current && !ref.current.contains(event.target)) {
            setIsMenuOpen(false)
          }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
          document.removeEventListener('mousedown', handleClickOutside)
        }
      },
      [ref]
    )
  }
  outsideClick(triggerRef)

  const projectLink =
    orderSource === 'order'
      ? ORDER_SUMMARY_URL && `${ORDER_SUMMARY_URL}/orders/${uuid}`
      : GEN1_BASE_URL && `${GEN1_BASE_URL}/video_projects/${uuid}`

  return (
    <>
      <tr className="item">
        {filterOptionsHelper(optionDropdownData, 'Order') && (
          <td className="thumbnail">
            <ProjectWrapper>
              <Thumbnail src={thumbnailUrl} />
              <ProjectName href={projectLink} target="_blank" rel="noopener noreferrer">
                {name}
              </ProjectName>
            </ProjectWrapper>
          </td>
        )}
        {filterOptionsHelper(optionDropdownData, 'Location') && (
          <td>{locationsHelper(locations)}</td>
        )}

        {filterOptionsHelper(optionDropdownData, 'Due Date') && (
          <td>{projectDate === 'Invalid date' ? '-' : projectDate}</td>
        )}
        {filterOptionsHelper(optionDropdownData, 'Created At') && <td>{createdDate}</td>}
        {filterOptionsHelper(optionDropdownData, 'Payment Type') && <td>{paymentType}</td>}
        {filterOptionsHelper(optionDropdownData, 'Workflow') && (
          <td>
            {shoots}x Shoot
            {shoots > 1 && 's'}, {videos}x Video
            {videos > 1 && 's'}
          </td>
        )}
        {filterOptionsHelper(optionDropdownData, 'Price') && (
          <td className="price">{priceCurrencyFormater(price, orderCurrency)}</td>
        )}
        {filterOptionsHelper(optionDropdownData, 'Contract Type') && (
          <td className={`contractType ${projectStatus.toLowerCase()}`}>{contractType}</td>
        )}
        {filterOptionsHelper(optionDropdownData, 'Status') && (
          <td className={`status ${projectStatus.toLowerCase()}`}>{projectStatus}</td>
        )}
        <td className="burger" onClick={() => setIsMenuOpen(!isMenuOpen)} ref={triggerRef}>
          {burgerIcon}
          {isMenuOpen && (
            <PopupMenu className="popup-menu">
              <Item
                icon="https://res.cloudinary.com/ninety-seconds/image/upload/v1661170997/icon-refresh.svg"
                onClick={async () => {
                  await reOrderProject({
                    variables: {
                      projectUuid: uuid,
                      orderType,
                    },
                  })
                  await setIsMenuOpen(false)
                  if (refetch) {
                    refetch()
                  }
                }}
              >
                Re-order
              </Item>
              <Item
                icon="https://res.cloudinary.com/ninety-seconds/image/upload/v1661170997/icon-publish.svg"
                onClick={async () => {
                  await duplicateProject({
                    variables: {
                      projectUuid: uuid,
                      projectLevel: 'TEMPLATES',
                    },
                  })
                  await setIsMenuOpen(false)
                  if (refetch) {
                    refetch()
                  }
                }}
              >
                Save to my templates
              </Item>
            </PopupMenu>
          )}
        </td>
      </tr>
      <tr className="item-separator" />
    </>
  )
}

export default React.memo(BrandOrderListNewItem)



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/BrandOrderListNew/BrandOrderListNewItem.tsx